export default __webpack_public_path__ + "static/media/delivery.b3634516.svg";